import { useState, useEffect } from "react";

export function useUserCity() {
  const [city, setCity] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!navigator.geolocation) {
      setLoading(false);
      return;
    }

    navigator.geolocation.getCurrentPosition(
      async (position) => {
        try {
          const { latitude, longitude } = position.coords;
          const res = await fetch(
            `https://api.bigdatacloud.net/data/reverse-geocode-client?latitude=${latitude}&longitude=${longitude}&localityLanguage=es`
          );
          const data = await res.json();
          const detectedCity = data.city || data.locality || null;
          setCity(detectedCity);
        } catch {
          // silently fail
        } finally {
          setLoading(false);
        }
      },
      () => {
        setLoading(false);
      },
      { timeout: 5000 }
    );
  }, []);

  return { city, loading };
}
